import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, Input } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateQuestionSetting } from "../../actions";

function LabelFunction() {
  const { question, questionId, languages, question_appearance_value,display } = useSelector((state) => ({
    question: state.question_checked_settings,
    questionId: state.question_checked,
    languages: state.languages,
    question_appearance_value: state.questionsList[state.question_checked]
      ? state.questionsList[state.question_checked].question_appearance_value
      : null,
    display: state.questionsList[state.question_checked].display
      ? state.questionsList[state.question_checked].display
      : [],
  }))
  const dispatch = useDispatch();
    return (
      <>
        <FormLabel component="legend" style={{color:"#000", fontWeight:"bold", fontSize:"1.2rem"}}>Question Label</FormLabel>
            <FormControlLabel
              control={
                <Checkbox  />
              }
              label="No label: "
              style={{marginBottom:0, justifyContent:"start"}}
              labelPlacement="start"
              checked={display?.indexOf('text-nolabel')>-1}
              onChange={(e)=>{
                if(e.target.checked){
                  dispatch(updateQuestionSetting(questionId,"display",[...display,'text-nolabel'],question_appearance_value))
                }else{
                  let temp = display
                  const index = temp.indexOf('text-nolabel');
                  if (index > -1){
                    temp.splice(index, 1);
                  } 
                  if (!temp.length > 0){
                    temp = [''];
                  } 
                  dispatch(updateQuestionSetting(questionId, "display", [...temp,''],question_appearance_value))
                }
              }}
            />
             {
              languages.map((lang,index) => {
                return (
                  <FormControl fullWidth style={{padding:"15px"}} key={`${questionId}_label::${lang}`}>
                    <FormLabel style={{color:"#000", fontWeight: "bold"}}>
                      {`Label ${lang}:`} 
                        {
                          index === 0 &&
                          <span style={{ color: 'red' }}> * </span>
                        }
                    </FormLabel>
                    <Input 
                      style={{marginTop:'0'}}
                      id={`${questionId}_label::${lang}`}
                      error={index===0 &&question[`label::${lang}`]?.length === 0}
                      onChange={(e) => {
                        dispatch(
                          updateQuestionSetting(
                            questionId,
                            `label::${lang}`,
                            e.target.value
                          )
                        );
                      }}
                      value={question[`label::${lang}`] || ''}
                      defaultValue={index === 0 ? question[`label::${lang}`] :''}
                    />
                    {
                      index===0 &&question[`label::${lang}`]?.length === 0 &&
                      <FormHelperText error id={`${questionId}_label::${lang}_label_helper_text`} >This field is required</FormHelperText>
                    }
                  </FormControl>
                )
              })
            }
      </>
  );
}

export default LabelFunction;
